module.exports = __webpack_public_path__ + "img/samsung-pay.1f71c6fd.svg";